// extracted by mini-css-extract-plugin
module.exports = {"CurveComponent":"styles_CurveComponent__3Jsc9","container":"styles_container__1Incc","curve":"styles_curve__187wH"};